<div fxLayout="row" fxLayoutGap="20px">
  <div fxFlex="0 0 auto" fxLayoutAlign="start center">
    <mat-icon>{{data.icon}}</mat-icon>
  </div>
  <div fxFlex="1 1 auto" fxLayoutAlign="start center" style="font-weight: bold">
    {{data.text}}
  </div>

  <!-- TODO: Subtext und actions einfügen -->
</div>


